module.exports = __webpack_public_path__ + "static/media/hide_raspberry.299c08ac.jpg";